// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import React from 'react'
import PropTypes from 'prop-types'
import { history } from 'syft-acp-core/history'

import { Button, ButtonGroup } from 'syft-acp-atoms/Button'
import { defaultWrapperPropTypes } from 'syft-acp-util/entityList'
import EmployerDetailListWrapper from '../EmployerDetailListWrapper'
import { EmployerAccountsVenueEmptyState, EmployerAccountsVenueSummary } from './EmployerAccountsVenueResults'

const newAction = employerID => () => {
  history.push(`/entity/employers/view/${employerID}/accounts/new`)
}

const AccountsControls = ({ employerID }) => (
  <ButtonGroup>
    <Button kind="success" disabled={!employerID} onClick={newAction(employerID)}>
      Invite new member
    </Button>
  </ButtonGroup>
)

AccountsControls.propTypes = {
  employerID: PropTypes.number,
}

AccountsControls.defaultProps = {
  employerID: null,
}

const venueResultsState = ({ venueID, isLoadingData, pagination = {}, query = {} }) => {
  const hasResults = Boolean(venueID) && !isLoadingData && typeof pagination.total === 'number'

  return {
    total: pagination.total,
    showSummary: hasResults && pagination.total > 0,
    showEmptyState: hasResults && pagination.total === 0,
    isSearching: Boolean(query.name || query.email),
  }
}

const EmployerAccountsListWrapper = props => {
  const { venueID, entityList } = props
  const { total, showSummary, showEmptyState, isSearching } = venueResultsState(props)

  return (
    <EmployerDetailListWrapper
      controlsRight={<AccountsControls />}
      {...props}
      beforeWrappedContent={
        showSummary ? (
          <EmployerAccountsVenueSummary venueID={venueID} isSearching={isSearching} total={total} />
        ) : undefined
      }
      entityList={
        showEmptyState ? (
          <EmployerAccountsVenueEmptyState venueID={venueID} isSearching={isSearching} />
        ) : (
          entityList
        )
      }
    />
  )
}
EmployerAccountsListWrapper.propTypes = defaultWrapperPropTypes

export default EmployerAccountsListWrapper
